import styled, { css, keyframes } from 'styled-components';
import { darkMode, darkPalette } from '../../core/theme';

const animateProgressBar = keyframes`
  0% { width: 0; }
  50% { width: 40%; }
  70% { width: 80%; }
  100% { width: 100%; }
`;

export const ProgressBarContainer = styled.div`
  width: 100%;
  height: 9px;
  background-color: #f3f3f3;
  border-radius: 10px;

  ${darkMode(css`
    background-color: ${darkPalette.iconSubtle};
  `)}
`;

export const ProgressBarFiller = styled.div`
  height: 100%;
  border-radius: inherit;
  background-color: #1f7ace;
  animation: ${animateProgressBar} 10s linear;

  ${darkMode(css`
    background-color: ${darkPalette.accentStrong};
  `)}
`;
